export const getAccessModalAction = (accountAccessMode: App.UiAccountModalMode | undefined, isOTPEnabled: boolean): 'sign_up_appear' | 'sign_up_details' | 'sign_in_password_or_otp' | 'sign_in_password' | 'sign_in_otp' | undefined => {
  if (!accountAccessMode) return

  const modeToActionMapping = {
    login: 'sign_up_appear',
    join: 'sign_up_details',
    loginPassword: isOTPEnabled ? 'sign_in_password_or_otp' : 'sign_in_password',
    loginOTP: 'sign_in_otp',
  }

  return modeToActionMapping[accountAccessMode]
}
